export const IS_FULL_REFERRAL_BANNER_IN_LB = 'is_full_referral_banner_in_lb';
export const IS_FAV_GAMES_LB_BANNER = 'is_fav_games_lb_banner';
